// extracted by mini-css-extract-plugin
module.exports = {"Token":"Orders_Token__-z5s4","Arrow":"Orders_Arrow__3MuDp","BoxArrow":"Orders_BoxArrow__23X7M"};